/**
 * Step is chosen so the tenant's own headcount lands exactly on a stop.
 * A 350-person pilot gets 10s; a 50,000-seat enterprise still gets 500s
 * rather than five thousand indistinguishable positions.
 */
export function headcountSliderBounds(headcount) {
    const actual = Number.isFinite(headcount) && headcount > 0 ? Math.round(headcount) : 5000;
    const step = actual < 1_000 ? 10 : actual < 10_000 ? 100 : 500;
    // Floor a decade below the tenant so the downside case is reachable, without
    // offering a scale that says nothing (a 2-person slider stop).
    const min = Math.max(step, Math.floor(Math.min(actual / 2, actual - step) / step) * step);
    const max = Math.max(actual * 4, actual + step, 1_000);
    return {
        min: Math.min(min, actual),
        max: Math.ceil(max / step) * step,
        step,
    };
}
//# sourceMappingURL=roi-slider-bounds.js.map